export default __webpack_public_path__ + "img/broken-heart.74148cbd.svg";